import FrameBuffer from './FrameBuffer';
import Bounds from '../utils/Bounds';
import Texture, { TextureSet, SpriteTexture } from './Texture';
import Renderer from './Renderer';

export default class RenderTarget {
	frameBuffer: FrameBuffer;
	texture: Texture;
	textureSet: TextureSet;
	depthBufferBinders: Array<WebGLBuffer>;
	width: number;
	height: number;

	private _initialized: Array<boolean>;

	constructor (width: number, height: number) {
		this.frameBuffer = new FrameBuffer(0, 0, width, height);
		this.texture = new Texture(null, { width, height });
		this.texture.name = 'render_target';
		this.textureSet = new TextureSet([new SpriteTexture(this.texture, new Bounds(0, width, 0, height))], 1);
		this._initialized = [];

		// TODO: optimize out depth buffer when unnecessary
		this.depthBufferBinders = [];

		this.width = width;
		this.height = height;
	}

	private _updateStorageBuffer (renderer: Renderer) {
		const gl = renderer.gl;
		gl.bindRenderbuffer(gl.RENDERBUFFER, this.depthBufferBinders[renderer.id]);
		gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, this.width, this.height);

	}

	private _initialize (renderer: Renderer) {
		// TODO: bind texture to frame buffer
		const gl = renderer.gl;

		// binding frame buffer with texture and depth buffer

		// saving currently used frame buffer
		const activeFrameBuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
		this.frameBuffer.bindFrameBuffer(renderer);
		// gl.bindFramebuffer(gl.FRAMEBUFFER, this.frameBuffer.binder);

		// binding frame buffer with texture
		const rendererID = renderer.id;
		this.texture.bindTexture(rendererID, gl);
		const textureBinder = this.texture.binders[rendererID];
		gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, textureBinder, 0);

		// creating depth buffer
		let depthBufferBinder = this.depthBufferBinders[rendererID];
		if (depthBufferBinder === undefined) {
			const newBinder = gl.createRenderbuffer();
			if (newBinder === null) {
				throw new Error('Could not create frame buffer');
			}

			this.depthBufferBinders[rendererID] = depthBufferBinder = newBinder;
		}

		this._updateStorageBuffer(renderer);

		// binding frame buffer with depth buffer
		gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, depthBufferBinder);

		// Resetting the currently used frame buffer
		gl.bindFramebuffer(gl.FRAMEBUFFER, activeFrameBuffer);
	}

	clear (renderer: Renderer) {
		if (this._initialized[renderer.id] === undefined) {
			this._initialize(renderer);
			this._initialized[renderer.id] = true;
		}

		if (this.width !== this.frameBuffer.width || this.height !== this.frameBuffer.height) {
			this.frameBuffer.setDimensions(0, 0, this.width, this.height);
			this._updateStorageBuffer(renderer);
			this.texture.setDimensions(this.width, this.height);
			this.texture.refreshTexture(renderer);
			// Note: no need to update the sprite coordinates as they will remain the same, i.e [0,1]x[0,1]
		}

		this.frameBuffer.clear(renderer);
	}

	// setDimensions (width: number, height: number) {
	// 	this.frameBuffer.setDimensions(0, 0, width, height);

	// 	// TODO: invalidate texture so that its dimension can be reset when used

	// 	gl.bindTexture(gl.TEXTURE_2D, this.texture.binder);
	// 	gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
		
	// 	// gl.bindRenderbuffer(gl.RENDERBUFFER, this.depthBufferBinder);
	// 	// gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, this._width, this._height);
	// };

	// delete () {
	// 	this.frameBuffer.delete();
	// 	this.texture.delete();

	// 	// if (this.depthBufferBinder !== null) {
	// 	// 	this._gl.deleteRenderbuffer(this.depthBufferBinder);
	// 	// 	this.depthBufferBinder = null;
	// 	// }
	// };
}
